import styled from "styled-components";

export const Interrogation = styled.img`

width: 22px;
margin-left: 8px;

cursor: pointer;
`

export const TextConfig = styled.span`

`